import * as z from 'zod';
import {id} from '../global/globalModels';

export const crmObjectType = z.enum(['COMPANY', 'CONTACT', 'DEAL', 'TICKET']);
export type CrmObjectType = z.infer<typeof crmObjectType>;

export const propertyType = z.enum(['bool', 'date', 'datetime', 'enumeration', 'number', 'string']);
export type PropertyType = z.infer<typeof propertyType>;

export const enumerationOption = z.object({
    value: z.string(),
    label: z.string(),
});
export type EnumerationOption = z.infer<typeof enumerationOption>;

export const propertyDefinition = z.object({
    name: z.string(),
    label: z.string(),
    type: propertyType,
    options: z.array(enumerationOption).optional(),
});
export type PropertyDefinition = z.infer<typeof propertyDefinition>;

export const customEventDefinitionView = z.object({
    id: id,
    eventName: z.string(),
    label: z.string(),
    primaryObject: crmObjectType,
    eventUid: z.string(),
    registered: z.boolean(),
    active: z.boolean(),
    description: z.string().nullable(),
    propertyDefinitions: z.array(propertyDefinition),
});
export type CustomEventDefinitionView = z.infer<typeof customEventDefinitionView>;

export const paginatedCustomEventDefinitionList = z.object({
    data: z.array(customEventDefinitionView),
    totalCount: z.number(),
});

export type CreateCustomEventDefinitionInput = {
    eventName: string;
    label: string;
    description?: string | null;
    primaryObject: CrmObjectType;
    propertyDefinitions: PropertyDefinition[];
};

export type UpdateCustomEventDefinitionInput = {
    label: string;
    description?: string | null;
    propertyDefinitions: PropertyDefinition[];
};
